import Box from '@mui/material/Box';
import { METHOD_COLORS } from '../constants';

interface Props {
  method: string;
}

export default function MethodBadge({ method }: Props) {
  const colors = METHOD_COLORS[method] || { bg: '#f4f4f5', text: '#71717a' };
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        px: 1,
        py: 0.25,
        borderRadius: '4px',
        bgcolor: colors.bg,
        color: colors.text,
        fontWeight: 700,
        fontSize: '0.65rem',
        fontFamily: "'JetBrains Mono', monospace",
        letterSpacing: '0.03em',
        minWidth: 42,
        textAlign: 'center',
      }}
    >
      {method}
    </Box>
  );
}
